import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LoginButton from '../../components/auth/LoginButton';

/**
 * Login page component that displays the Google OAuth login option
 * Handles authentication errors and provides helpful guidance
 */
const LoginPage: React.FC = () => {
  const location = useLocation();

  // Extract URL parameters
  const searchParams = new URLSearchParams(location.search);
  const error = searchParams.get('error');

  // Function to get error message and guidance based on error type
  const getErrorContent = (errorType: string | null) => {
    switch (errorType) {
      case 'google_auth_failed':
        return {
          title: 'Account Not Found',
          message: 'We couldn\'t find an account associated with your Google account.',
          guidance: 'If you\'re new here, you\'ll need to create an account first.',
          actionText: 'Create Account',
          actionLink: '/register'
        };
      case 'server_error':
        return {
          title: 'Server Error',
          message: 'We encountered a technical issue while trying to sign you in.',
          guidance: 'Please try again in a few moments.',
          actionText: 'Try Again',
          actionLink: '/login'
        };
      default:
        return null;
    }
  };

  const errorContent = getErrorContent(error);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              {/* Display error message if present */}
              {error && (
                <div className="alert alert-danger d-flex align-items-center mb-4">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  <div>
                    <strong>Authentication Error:</strong> {error}
                  </div>
                </div>
              )}
              
              <div className="text-center mb-4">
                <h2 className="fw-bold">Welcome Back</h2>
                <p className="text-muted">Sign in to continue</p>
              </div>
              
              <div className="d-grid gap-3">
                <LoginButton 
                  label="Sign in with Google" 
                  className="btn btn-primary btn-lg"
                />
              </div>
              
              <div className="mt-4 text-center">
                <p className="mb-0">
                  Don't have an account?{' '}
                  <Link to="/register" className="text-decoration-none fw-semibold">
                    Sign up with Google
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 